/**
 * Zone outlines for the region hover preview.
 *
 * Bounding boxes were a poor stand-in: a region is a chain of coastal zones,
 * and boxing each one drew a heap of overlapping rectangles that said little
 * about where the water actually is.
 *
 * The exact geometry cannot be fetched on a hover — NWS serves it one zone at a
 * time at around 60 KB, so Anchorage West's 36 zones would be two megabytes. So
 * a simplified copy of every zone in the country ships instead, 72 KB gzipped,
 * in its own chunk fetched the first time a region is hovered. Zoomed out far
 * enough to see a whole region, the simplification is invisible.
 *
 * Exact geometry is still fetched per zone when a forecast card is lit; this is
 * only for showing where a region reaches.
 */

let cache: Record<string, GeoJSON.Geometry> | null = null;
let inFlight: Promise<Record<string, GeoJSON.Geometry>> | null = null;

/** The outline table, loaded once. */
export function zoneOutlines(): Promise<Record<string, GeoJSON.Geometry>> {
  if (cache) return Promise.resolve(cache);
  if (inFlight) return inFlight;

  inFlight = import('../marineZoneShapes')
    .then((m) => {
      cache = m.ZONE_OUTLINES;
      return cache;
    })
    .catch((err) => {
      inFlight = null;
      throw err;
    });

  return inFlight;
}

/** The outlines already in hand, or null if the chunk has not arrived yet. */
export function loadedOutlines(): Record<string, GeoJSON.Geometry> | null {
  return cache;
}
